module.exports = __webpack_public_path__ + "static/media/loader.bd0201f1.gif";